import React, { ReactNode, useMemo } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { Asset } from '@/types/models/assets.types';
import { FilterSideMenu } from '@/modules/shared/FilterSideMenu';
import { useComponentSelector } from './useComponentSelector';
import { useActiveTab } from '@/hooks/shared';

interface ComponentSelectorProps {
  asset?: any;
  components: any[];
  maintenanceDataset?: any[];
  isLoading: boolean;
  parentItem?: Asset;
  currentComponents: any[];
  cardTitle?: ReactNode | string;
  additionalCounters?: any;
  onItemClick?: (data: any) => void;
}

export const ComponentSelector = ({
  asset,
  components,
  isLoading,
  currentComponents,
  additionalCounters,
}: ComponentSelectorProps) => {
  const { items, uiUnits, groupKey, defaultVal, cardTitle, handelFilterUpdate, variant, onItemClick } =
    useComponentSelector({
      components,
      currentComponents,
      asset,
      additionalCounters,
    });

  const { isDiagnostics } = useActiveTab();

  // Hide observation icons when on Diagnostics tab
  // Actions are always hidden (not ready yet)
  const visibilityConfig = useMemo(
    () => ({
      observations: !isDiagnostics,  // Hide on Diagnostics page only
      actions: false,                // Always hidden - not ready yet
    }),
    [isDiagnostics]
  );

  return isLoading ? (
    <Skeleton className="h-full w-full" />
  ) : (
    <FilterSideMenu
      variant={variant}
      title={cardTitle}
      items={items}
      defaultSelected={defaultVal}
      onFilterChange={handelFilterUpdate}
      uiUnits={uiUnits}
      groupKey={groupKey}
      onClick={onItemClick}
      visibilityConfig={visibilityConfig}
    />
  );
};
